const NAMESPACE = "previewWebAdapterUrl";

const KEYS = {
    fullProductionUrlDescription: "fullProductionUrlDescription",
    fullTestUrlDescription: "fullTestUrlDescription"
};

const MESSAGES = {
    [KEYS.fullProductionUrlDescription]: {
        value: "Full production URL preview, including relative path:",
        comment: "Description for the Full URL for Production input"
    },
    [KEYS.fullTestUrlDescription]: {
        value: "Full test URL preview, including relative path:",
        comment: "Description for the Full URL for Test input"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
